import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";

import { getStackPullRequestSingleRun } from "../../../helpers";
import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestTitleCell = ({
  item: pullRequest,
  stackId,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  const singleRun = getStackPullRequestSingleRun(pullRequest.runs);

  return (
    <StackPullRequestsTableGroupCell
      item={pullRequest}
      stackId={stackId}
      {...cellProps}
      role="rowheader"
    >
      {!!singleRun && (
        <TableCellLink
          href={`/stack/${stackId}/run/${singleRun.id}`}
          routerOptions={{ state: { prUrl: pullRequest.url, prTitle: pullRequest.title } }}
        >
          {pullRequest.title}
        </TableCellLink>
      )}

      {!singleRun && <TableCellText>{pullRequest.title}</TableCellText>}
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestTitleCell;
